import { render, staticRenderFns } from "./Leads.html?vue&type=template&id=13fd6e6a&scoped=true&external"
import script from "./Leads.js?vue&type=script&lang=js&external"
export * from "./Leads.js?vue&type=script&lang=js&external"
import style0 from "./Leads.scss?vue&type=style&index=0&id=13fd6e6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd6e6a",
  null
  
)

export default component.exports